/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Icon } from '@insticator/insticator-ui'; // iui-material
// utils
import { isContentValid } from 'utils/embedcontentvalidation';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/steps/stepindicator/arrowstep/arrowstep_styles';



/* ========== ~~~~~~~~~~ STEP INDICATOR : ARROW STEP ~~~~~~~~~~ ========== */
const ArrowStep = (props) => {
	const handleClick = (e) => {
		e.preventDefault();
		props.currStepName === 'customize' ? moveWithValidation(props.data.name) : props.moveToPage(props.data.name);
	};
	const moveWithValidation = (target) => {
        if(isContentValid(props.selectedContent)) {
            props.moveToPage(target)
        } else {
            props.invalidateSelectedContent();
            props.sendMessage('There are required fields you must fill out before continuing.');
        }
    };
    const isComplete = props.index < props.currentStepIndex;
    return(
    	<div className={`arrowstep step ${props.classes.arrowstep} ${props.data.name} ${props.data.name === props.currentStepPage ? 'active' : 'inactive'} isComplete-${isComplete} isSavingData-${props.isSavingData} changeDetected-${props.changeDetected}`} onClick={handleClick}>
            <div className={`desc`}>
                <Icon name={`check-circle`} />
    			<div className={`text`}>{props.data.title}</div>
            </div>
		</div>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ArrowStep);
